import WebConstant from "../../webConstants";
import { mainWrapper } from "../../main";


function patientList(params) {
    return mainWrapper.get(WebConstant.host + "/patient", params);
};


function patientDetails(id) {
    return mainWrapper.get(WebConstant.host + `/patient/${id}`);
};


function patientCreate(params) {
    return mainWrapper.post(WebConstant.host + `/patient`, params);
};


function patientUpdate(id) {
    return mainWrapper.put(WebConstant.host + `/patient/${id}`,);
};


function patientDelete(id) {
    return mainWrapper._delete(WebConstant.host + `/patient/${id}`);
};


export const patientServices = {
    patientList,
    patientDetails,
    patientCreate,
    patientUpdate,
    patientDelete,
};
